import React from 'react';

import { Alert, AlertDescription, Button } from '@zapier/design-system';

import { useZapUrl } from 'app/developer-v3/hooks';

type Props = {
  type: 'trigger' | 'action';
};

export default function CtaCreateZap({ type }: Props) {
  const getZapUrl = useZapUrl();

  return (
    <Alert title={`Next up — Create a Zap with this ${type}!`}>
      <AlertDescription>
        Be sure to turn it on and let it run at least once with real data. This
        is required before publishing.
      </AlertDescription>
      <Button href={getZapUrl()} target="_blank">
        Create a Zap
      </Button>
    </Alert>
  );
}
